import React from 'react';
import PropTypes from 'prop-types';

import {connectModuleEnv} from '../oe-module-env';
import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import OEOverlayFactory from './oe-overlay-factory';
import OEAnimateHelper from '../../lib/animation/oe-animate-helper';
import OEToolbox from '../../lib/tools/oe-toolbox';
import {OECustomPropertyName} from '../../react-oe/oe-custom-property-name';
import {AnimationTimerComponent} from '../../lib/animation/animation-timer';

export class OEOverlayContainer extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.edgeOffsets = {top: 0, right: 0, bottom: 0, left: 0};

        this.onTimerFrame = this.onTimerFrame.bind(this);
        this.onRef = this.onRef.bind(this);

        this.onEdgeOffsetsChanged = this.onEdgeOffsetsChanged.bind(this);
    }

    getEdgeOffsets()    {
        return this.edgeOffsets;
    }

    onConnect()  {
        this.sendFrame();
    }

    sendFrame() {
        if(!this.frame || !this.oe.isReady())   return;
        let dpr = this.oe.Module.devicePixelRatio();
        this.oe.sharedInterface.setCustomFloatProperty(OECustomPropertyName.overlayFrame, {vec: {x: dpr * this.frame.x, y: dpr * this.frame.y, z: dpr * this.frame.w, w: dpr * this.frame.h}});
    }

    updateFrame(props_)   {
        if(!this.ref)  return;
        let rect = this.ref.getBoundingClientRect();
        let frame = {x: rect.left, y: rect.top, w: rect.right - rect.left, h: rect.bottom - rect.top};

        if(OEToolbox.shallowEqual(frame, this.frame))   return;
        this.frame = frame;
        this.sendFrame();
        //console.log('OEOverlayContainer frame - x: ' + frame.x + ', y: ' + frame.y + ', w: ' + frame.w  + ', h: ' + frame.h);
    }

    onTimerFrame()  {
        this.updateFrame();
    }

    onRef(ref)  {
        this.ref = ref;
        if(ref) this.updateFrame();
    }

    render() {
        let animate = this.props.animate;
        if(typeof(animate) === 'boolean')   animate = {top: animate, right: animate, bottom: animate, left: animate};

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <div
                    className={'overlay-container ' + this.props.className}
                    style={{
                            top: this.props.insets.top.toString() + 'px',
                            right: this.props.insets.right.toString() + 'px',
                            bottom: this.props.insets.bottom.toString() + 'px',
                            left: this.props.insets.left.toString() + 'px',
                            transition: OEAnimateHelper.transitionForInsets(animate)
                        }}
                    ref={this.onRef}
                >
                    <AnimationTimerComponent play={true} onFrame={this.onTimerFrame}/>
                    <OEOverlayFactory moduleId={this.props.moduleId} target={this.props.target} onEdgeOffsetsChanged={this.onEdgeOffsetsChanged}/>
                </div>
            </React.Fragment>
        );
    }

    onEdgeOffsetsChanged(sender, edgeOffsets, animate) {
        this.edgeOffsets = edgeOffsets;
        if(this.props.onEdgeOffsetsChanged) this.props.onEdgeOffsetsChanged(edgeOffsets); 

        this.props.uiStateManager.updateState({overlay: {edgeOffsets : {$set: Object.assign({animate: animate}, edgeOffsets)}}});
    }
}

OEOverlayContainer.defaultProps = {
    className: '',
    moduleId: '',
    insets: {top: 0, right: 0, bottom: 0, left: 0},
    animate: false
};

OEOverlayContainer.propTypes = {
    className: PropTypes.string,
    moduleId: PropTypes.string,
    insets: PropTypes.shape({
        top: PropTypes.number,
        right: PropTypes.number,
        bottom: PropTypes.number,
        left: PropTypes.number
    }),
    animate: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
        top: PropTypes.bool,
        right: PropTypes.bool,
        bottom: PropTypes.bool,
        left: PropTypes.bool
    })]),
    onEdgeOffsetsChanged: PropTypes.func
};

export default connectModuleEnv((env, setEnv, updateEnv) => {
    return {
        uiStateManager: env.component.uiStateManager,
    };
})(OEOverlayContainer);